const CLARITY_SCRIPT_ID = 'ms-clarity';
const CLARITY_PROJECT_ID_PATTERN = /^[a-z0-9]+$/i;

/**
 * Injeta o snippet oficial do Microsoft Clarity uma única vez.
 * No-op quando `projectId` está vazio/inválido ou o script já foi injetado.
 */
export function loadClarity(projectId?: string): void {
	const id = projectId?.trim();

	if (!id || !CLARITY_PROJECT_ID_PATTERN.test(id)) return;
	if (typeof window === 'undefined' || document.getElementById(CLARITY_SCRIPT_ID)) return;

	try {
		window.clarity =
			window.clarity ||
			function (...args: unknown[]) {
				(window.clarity!.q = window.clarity!.q || []).push(args);
			};

		const script = document.createElement('script');
		script.id = CLARITY_SCRIPT_ID;
		script.async = true;
		script.src = `https://www.clarity.ms/tag/${encodeURIComponent(id)}`;

		const firstScript = document.getElementsByTagName('script')[0];
		if (firstScript?.parentNode) {
			firstScript.parentNode.insertBefore(script, firstScript);
		} else {
			document.head.appendChild(script);
		}
	} catch {}
}
